import React from 'react'
import { Button } from '@chakra-ui/react'
import { toast } from 'react-toastify'
import { useGetExportHourlyCSVMutation } from '../../reports/api/reportsApi'
import { formatDateString } from '../../../utils/helpers'

interface Props {
    startDate: any
    endDate: any
    deviceIds: number[]
    reportName: string
    reportType: string
    ibexPrice?: number
    groupIds?: number[]
    locationIds?: number[]
}

export default function DownloadCSVButton(props: Props) {
    const [triggerExport] = useGetExportHourlyCSVMutation()

    const handleDownload = async () => {
        const toastId = toast.info('Exporting...', {
            style: { padding: '10px 20px' },
            autoClose: false,
            isLoading: true,
            progress: undefined,
        })
        try {
            const blob = await triggerExport({
                start: formatDateString(props.startDate),
                end: formatDateString(props.endDate),
                device_ids: props.deviceIds,
                file_name: props.reportName,
                group_ids: props.groupIds,
                raw_data_type: props.reportType,
                location_ids: props.locationIds
            }).unwrap()

            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = `${props.reportName}.csv`
            a.click()
            window.URL.revokeObjectURL(url)

            toast.update(toastId, {
                render: 'Export successful!',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
            })
        } catch (error) {
            toast.update(toastId, {
                render: `Failed to export`,
                type: 'error',
                isLoading: false,
                autoClose: 3000,
            })
        }
    }

    return (
        <Button
            size="md"
            onClick={handleDownload}
        >
            Download CSV
        </Button>
    )
}
